<div class="info-tooltip-container" (click)="openInfo()">
	<div class="info-tooltip-box">
		<img
			class="info-icon"
			src="../../../../assets/icons/info.svg"
			alt="info-icon"
		/>
		<span class="info-text">{{
			'old_version_flag.flag_title' | translate
		}}</span>
	</div>
	<div class="info-tooltip-arrow"></div>
</div>
